export default "__VITE_ASSET__Dol_9zH7__"